import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';

import { ActType, ActInfo } from '../states/approvalState';

type Props = {
  open: boolean;
  actTypes: ActType[];
  actInfo: ActInfo;
  startDate: string;
  setStateActInfo: (i: ActInfo) => void;
  handleClose: () => void;
  handleOk: () => void;
};

export const ActInfoDialog: React.FC<Props> = (props) => {

  const handlePublicDate = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newInfo = Object.assign({}, props.actInfo);
    newInfo.publicationDate = (event.target as HTMLInputElement).value;
    props.setStateActInfo(newInfo);
  };
  const handleActType = (event: SelectChangeEvent) => {
    const newInfo = Object.assign({}, props.actInfo);
    newInfo.actType = (event.target as HTMLInputElement).value;
    props.setStateActInfo(newInfo);
  };
  const handleActNum = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newInfo = Object.assign({}, props.actInfo);
    newInfo.actNum = (event.target as HTMLInputElement).value;
    props.setStateActInfo(newInfo);
  };
  const handleActEdaNum = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newInfo = Object.assign({}, props.actInfo);
    newInfo.actEdaNum = (event.target as HTMLInputElement).value;
    props.setStateActInfo(newInfo);
  };
  const handleActMagoNum = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newInfo = Object.assign({}, props.actInfo);
    newInfo.actMagoNum = (event.target as HTMLInputElement).value;
    props.setStateActInfo(newInfo);
  };
  const handleActNumOption = (event) => {
    const newInfo = Object.assign({}, props.actInfo);
    newInfo.actNumOptionViewFlag = event.target.checked;
    props.setStateActInfo(newInfo);
  };
  const handleActNumOptionTextField = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newInfo = Object.assign({}, props.actInfo);
    newInfo.actNumOption = (event.target as HTMLInputElement).value;
    props.setStateActInfo(newInfo);
  };
  const handleExpireDate = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newInfo = Object.assign({}, props.actInfo);
    newInfo.expireDate = (event.target as HTMLInputElement).value;
    props.setStateActInfo(newInfo);
  };
  const handleBeforeEnactmentTextField = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newInfo = Object.assign({}, props.actInfo);
    newInfo.beforeEnactment = (event.target as HTMLInputElement).value;
    props.setStateActInfo(newInfo);
  };
  const handleAfterEnactmentTextField = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newInfo = Object.assign({}, props.actInfo);
    newInfo.afterEnactment = (event.target as HTMLInputElement).value;
    props.setStateActInfo(newInfo);
  };
  const handlePreambleTextField = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newInfo = Object.assign({}, props.actInfo);
    newInfo.preamble = (event.target as HTMLInputElement).value;
    props.setStateActInfo(newInfo);
  };

  const [subDialog, setSubDialog] = React.useState(false);
  const openSubDialog = Boolean(subDialog);
  const closeSubDialog = () => setSubDialog(false);

  const viewActNum = () => {
    return (
      <>
        <TextField
          id="standard-number"
          label="番号"
          type="number"
          value={props.actInfo.actNum || ''}
          onChange={handleActNum}
          sx={{
            margin: (theme) => theme.spacing(1),
            width: 100,
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        {props.actInfo.actNum ? (
          <TextField
            id="standard-number"
            label="枝番号"
            type="number"
            value={props.actInfo.actEdaNum || ''}
            onChange={handleActEdaNum}
            sx={{
              margin: (theme) => theme.spacing(1),
              width: 100,
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        ) : (
          <TextField
            disabled
            id="standard-number"
            label="枝番号"
            type="number"
            value=""
            sx={{
              margin: (theme) => theme.spacing(1),
              width: 100,
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        )}
        {props.actInfo.actNum && props.actInfo.actEdaNum ? (
          <TextField
            id="standard-number"
            label="孫番号"
            type="number"
            value={props.actInfo.actMagoNum || ''}
            onChange={handleActMagoNum}
            sx={{
              margin: (theme) => theme.spacing(1),
              width: 100,
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        ) : (
          <TextField
            disabled
            id="standard-number"
            label="孫番号"
            type="number"
            value=""
            sx={{
              margin: (theme) => theme.spacing(1),
              width: 100,
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        )}
      </>
    );
  };

  const viewActNumOption = () => {
    return (
      <>
        <InputLabel id="demo-simple-select-label" sx={{
            margin: (theme) => theme.spacing(1),
            width: 100,
        }} >任意表示</InputLabel>
        <Checkbox
          checked={props.actInfo.actNumOptionViewFlag}
          onChange={handleActNumOption}
          inputProps={{ 'aria-label': 'primary checkbox' }}
        />
        {props.actInfo.actNumOptionViewFlag ? (
          <TextField
            id="ActNumOption-TextField"
            // label="ActNumOption"
            type="string"
            value={props.actInfo.actNumOption || ''}
            onChange={handleActNumOptionTextField}
            sx={{
              margin: (theme) => theme.spacing(1),
              width: 200,
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        ) : (<TextField
          disabled
          id="ActNumOption-TextField"
          // label="ActNumOption"
          type="string"
          value={props.actInfo.actNumOption || ''}
          onChange={handleActNumOptionTextField}
          sx={{
            margin: (theme) => theme.spacing(1),
            width: 200,
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />)}
      </>
    );
  };

  const handlePreOk = () => {
    if (props.actInfo.publicationDate) {
      const sStartDate = new Date(props.startDate);
      const sOPDate = new Date(props.actInfo.publicationDate);
      if (sStartDate.getTime() <= sOPDate.getTime()) {
        props.handleOk();
      } else {
        setSubDialog(true);
      }
    } else {
      props.handleOk();
    }
  }

  return (
    <Dialog
      open={props.open}
      keepMounted
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">{"制定情報設定"}</DialogTitle>
      <DialogContent sx={{
        minHeight: 500,
      }}>
        <TextField
          id="date"
          label="公開日(公布日)"
          type="date"
          value={props.actInfo.publicationDate || ''}
          onChange={handlePublicDate}
          sx={{
            margin: (theme) => theme.spacing(1),
            width: 200,
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <br />
        <FormControl sx={{
          margin: (theme) => theme.spacing(1),
          minWidth: 120,
        }}>
          <InputLabel id="demo-simple-select-label">種別</InputLabel>
          <Select
            labelId="simple-select-label"
            id="simple-select"
            label="種別"
            value={props.actInfo.actType || '0'}
            onChange={handleActType}
          >
            {props.actTypes.map((type) => {
              return (<MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>);
            })}
          </Select>
        </FormControl>
        <br />
        {viewActNum()}
        <br />
        {viewActNumOption()}
        <br />
        <TextField
          id="date"
          label="失効日"
          type="date"
          value={props.actInfo.expireDate || ''}
          onChange={handleExpireDate}
          sx={{
            margin: (theme) => theme.spacing(1),
            width: 200,
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <br />
        <TextField
          id="BeforeEnactment-TextField"
          label="題名前制定文"
          type="string"
          value={props.actInfo.beforeEnactment || ''}
          onChange={handleBeforeEnactmentTextField}
          sx={{
            margin: (theme) => theme.spacing(1),
            width: 200,
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <br />
        <TextField
          id="AfterEnactment-TextField"
          label="題名後制定文"
          type="string"
          value={props.actInfo.afterEnactment || ''}
          onChange={handleAfterEnactmentTextField}
          sx={{
            margin: (theme) => theme.spacing(1),
            width: 200,
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <br />
        <TextField
          id="Preamble-TextField"
          label="前文"
          type="string"
          value={props.actInfo.preamble || ''}
          onChange={handlePreambleTextField}
          sx={{
            margin: (theme) => theme.spacing(1),
            width: 200,
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handlePreOk} color="primary">
          OK
        </Button>
        <Button onClick={props.handleClose} color="primary">
          キャンセル
        </Button>
      </DialogActions>
      <Dialog
        open={openSubDialog}
        keepMounted
        onClose={closeSubDialog}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">公開日(公布日)が正しくありません。</DialogTitle>
        <DialogContent>
          <Typography>公開日(公布日)はシステム利用開始日（{props.startDate}）以降で入力してください。</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeSubDialog} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};
